import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAuHp7vlQjFkYkTA4G2tCQsrmzlWjQ_BLw",
  authDomain: "uuest-vs-musty.firebaseapp.com",
  projectId: "uuest-vs-musty",
  storageBucket: "uuest-vs-musty.firebasestorage.app",
  messagingSenderId: "980678237219",
  appId: "1:980678237219:web:3cbc21e29f51361939e596",
  measurementId: "G-823F5VRQEE"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const auth = getAuth(app);

export default app; 